import { TSupportedLayerTypes } from '../../../../components/Floors/interfaces';
import { AvailableReportingObjectsTypes } from '../interfaces';

export const LAYER_TYPE_BY_REPORTING_OBJECT_TYPE: { [reportingObjectType: string]: TSupportedLayerTypes } = {
    [AvailableReportingObjectsTypes.Floor]: 'perimeter_layer',
    [AvailableReportingObjectsTypes.Tenant]: 'tenants_layer',
    [AvailableReportingObjectsTypes.Zone]: 'zones_layer',
};
